const AwardsCards = ({index,position,hackathon,host,date,moreInfo}) => {
    return ( 
        <div className="flex flex-row mt-10  sm:w-full">
            <h1 className="text-lg sm:text-4xl font-notoSans mr-2 sm:mr-3 ">{index}</h1>
            <div className="block uppercase w-full">
                <div className=" flex flex-row justify-between font-openSans text-xs sm:text-sm text-gray-500" >
                    <h1 className="font-medium">{hackathon}</h1>
                    <h1 className="ml-8 sm:ml-16 font-semibold ">{host}</h1>
                </div>
                
                <div>
                    <h1 className="sm:font-semibold font-medium text-lg sm:text-xl ">{position}</h1>

                    <div className="mt-1 sm:mt-2 flex flex-row justify-between text-xs text-gray-400">
                        <span className="font-medium">{date}</span>
                        <a href={moreInfo} className="ml-2 py-0 px-2 bg-sky-600 text-white hover:bg-sky-700" >more info</a>
                    </div>
                </div>
            </div>
        </div>
     );
}
 
export default AwardsCards;